// extracted by mini-css-extract-plugin
module.exports = {"power-independence-K":"K_power-independence-K__yFSi3"};